<div class="otp-page">

  
  <div class="otp-card">
   
    <div class="icons">
       <!-- Close -->
    <button
      type="button"
      class="close-button"
      aria-label="Close"
      (click)="closeDialog()"
    >
      <span>×</span>
    </button>
 <!-- Icon -->
    <div class="otp-icon">
       
      <span class="lock-icon">✓</span>
     
    </div>
      <div style="background-color: red;"></div>

    </div>
   


    <!-- Header -->
    <div class="otp-header">

      <h2>
        {{ 'OTP.TITLE' | translate }}
      </h2>

      <p>
        {{ 'OTP.DESCRIPTION' | translate }}
      </p>

      <div class="phone-number">
        {{ phoneNumber() }}
      </div>

    </div>


    <!-- OTP -->
    <form
      [formGroup]="otpForm"
      (ngSubmit)="verifyOtp()"
      class="otp-form"
    >

     
<div class="otp-inputs" dir="ltr">

  <input
    #otpInput
    type="text"
    inputmode="numeric"
    autocomplete="one-time-code"
    maxlength="6"
    formControlName="otp"
    aria-label="6 digit OTP"
    (input)="onOtpInput($event)"
  />

</div>


      <!-- Attempts -->
      @if (attemptsRemaining() < 5 && attemptsRemaining() > 0) {

        <div class="attempts">
          {{ 'OTP.ATTEMPTS_REMAINING' | translate }}
          <strong>{{ attemptsRemaining() }}</strong>
        </div>

      }


      <!-- Error -->
      @if (errorMessage()) {

        <div class="message message-error">
          {{ errorMessage() }}
        </div>

      }


      <!-- Success -->
      @if (successMessage()) {

        <div class="message message-success">
          {{ successMessage() }}
        </div>

      }


      <!-- Verify -->
      <button
        type="submit"
        class="verify-button"
        [disabled]="isLoading()"
      >

        @if (isLoading()) {

          <span class="spinner"></span>

          <span>
            {{ 'OTP.VERIFYING' | translate }}
          </span>

        } @else {

          <span>
            {{ 'OTP.VERIFY' | translate }}
          </span>

        }

      </button>

    </form>


    <!-- Resend -->
    <div class="resend-section">

      <span class="resend-label">
        {{ 'OTP.DID_NOT_RECEIVE' | translate }}
      </span>

      @if (!canResend()) {

        <span class="timer">
          {{ 'OTP.RESEND_IN' | translate }}
          <strong>
            {{ secondsRemaining() }}s
          </strong>
        </span>

      } @else {

        <button
          type="button"
          class="resend-button"
          [disabled]="isResending()"
          (click)="resendOtp()"
        >

          @if (isResending()) {
            {{ 'OTP.SENDING' | translate }}
          } @else {
            {{ 'OTP.RESEND' | translate }}
          }

        </button>

      }

    </div>


    <!-- Security note -->
    <div class="security-note">

      <span class="security-icon">•</span>

      <span>
        {{ 'OTP.SECURITY_NOTE' | translate }}
      </span>

    </div>

  </div>

</div>